/* Help / FAQ page behaviour (sections/ll-help.liquid): topic index + reader, and search across every question. */
(() => {
  const root = document.querySelector('.ll-hp');
  if (!root) return;
  const idx = root.querySelector('.pl-idx'), tabs = [...idx.querySelectorAll('[role=tab]')], pans = [...root.querySelectorAll('.pl-pan')];
  const none = root.querySelector('.none'), q = root.querySelector('#hpQ'), res = root.querySelector('.res'), list = root.querySelector('#questions');
  let cur = 0;

  const showTopic = (i, focus) => {
    cur = (i + tabs.length) % tabs.length;
    tabs.forEach((t, j) => { t.setAttribute('aria-selected', j === cur); t.tabIndex = j === cur ? 0 : -1; });
    pans.forEach((p, j) => { p.hidden = j !== cur; });
    if (focus) tabs[cur].focus();
  };
  tabs.forEach((t, i) => {
    t.addEventListener('click', () => { if (q.value) { q.value = ''; search(); } showTopic(i); });
    t.addEventListener('keydown', (e) => { const d = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[e.key]; if (d) { e.preventDefault(); showTopic(cur + d, true); } });
  });

  // search: show every topic's matching questions at once, open the matches, dim topics with no hits
  const items = pans.map((p) => [...p.querySelectorAll('details')].map((d) => ({ d, text: d.textContent.toLowerCase() })));
  const search = () => {
    const words = q.value.toLowerCase().trim().split(/\s+/).filter(Boolean);
    idx.classList.toggle('searching', words.length > 0);
    if (!words.length) {
      items.flat().forEach(({ d }) => { d.hidden = false; d.open = false; });
      none.hidden = true; res.hidden = true; showTopic(cur); return;
    }
    let total = 0;
    items.forEach((list, j) => {
      let hits = 0;
      list.forEach(({ d, text }) => { const ok = words.every((w) => text.includes(w)); d.hidden = !ok; d.open = ok; hits += ok; });
      pans[j].hidden = !hits; tabs[j].dataset.hits = hits; total += hits;
    });
    none.hidden = total > 0;
    res.hidden = false;
    res.querySelector('b').textContent = `${total || 'No'} answer${total === 1 ? '' : 's'} for "${q.value.trim()}"`;
  };
  // typing takes you down to the answers once you pause (or press Enter), unless they're already in view
  let wait;
  const goToAnswers = () => { clearTimeout(wait); if (q.value.trim() && list.getBoundingClientRect().top > innerHeight * .5) list.scrollIntoView({ behavior: 'smooth' }); };
  q.addEventListener('input', () => { search(); clearTimeout(wait); wait = setTimeout(goToAnswers, 700); });
  q.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); goToAnswers(); } });
  res.querySelector('button').addEventListener('click', () => { q.value = ''; search(); });

  // /pages/faq#delivery (any topic name) opens that topic
  const want = decodeURIComponent(location.hash.slice(1)).toLowerCase();
  const hit = tabs.findIndex((t) => t.textContent.toLowerCase().startsWith(want));
  if (want && hit > -1) { showTopic(hit); root.querySelector('#questions').scrollIntoView(); }
})();
